// import { useState, useEffect } from 'react';
import { useSelector, StateProps } from 'react-redux';

function useProfile() {
  const account = useSelector((state:StateProps) => state.account);
  return account.user
}

export default useProfile